import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import css from './index.scss';

import { FILE_TYPES } from '../../constants';

import Button from '../button';

/**
 * FILE UPLOAD
 * ----------------------
 * Used in components/curriculum-documents to manage file upload
 * uses click event from hidden input ref to provide similar UI to provided wireframe
 */
const FileUpload = ({
    buttonLabel,
    fileName,
    inputRef,
    labelText,
    onChangeHandler
}) => (
    <div className={css.fileUploadContainer}>
        <input
            type="file"
            ref={inputRef}
            onChange={onChangeHandler}
            accept={FILE_TYPES.PDF}
            className={css.fileUploadHiddenInput}
        />
        <span>{labelText}</span>
        <div title={fileName || ''}>
            <input
                value={fileName || ''}
                className={css.fileUploadInput}
            />
        </div>
        <Button
            label={buttonLabel}
            handleOnClick={() => inputRef.current.click()}
            variant="dark"
            containerClassName={css.fileUploadButton}
        />
    </div>
);

FileUpload.propTypes = {
    buttonLabel: PropTypes.string,
    fileName: PropTypes.string,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    labelText: PropTypes.string,
    onChangeHandler: PropTypes.func
};

export default styleable(css)(FileUpload);



// WEBPACK FOOTER //
// ./app/components/file-upload/index.js